import axios from '../utils/axios';

export default function fetchJobsCount(adminId,params) {
    return (
        axios.get('/admin/'+ adminId+'/all-jobs/count',{
            params:params
        })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
